import { render, staticRenderFns } from "./DisplaySettingEdit.vue?vue&type=template&id=13f540fa&scoped=true&"
import script from "./DisplaySettingEdit.vue?vue&type=script&lang=js&"
export * from "./DisplaySettingEdit.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySettingEdit.vue?vue&type=style&index=0&id=13f540fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f540fa",
  null
  
)

export default component.exports